import { render, staticRenderFns } from "./PaymentSection.vue?vue&type=template&id=34709a26&scoped=true"
import script from "./PaymentSection.vue?vue&type=script&lang=js"
export * from "./PaymentSection.vue?vue&type=script&lang=js"
import style0 from "./PaymentSection.vue?vue&type=style&index=0&id=34709a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34709a26",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgRender: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/SvgRender.vue').default,Link: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Link.vue').default,Layout: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Layout.vue').default})
